<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar
          flat
        >
          <v-btn
            class="mr-4"
            color="primary"
            @click="setToday"
          >
            Hoje
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-toolbar-title class="text-caption text-sm-body-2 text-md-body-1 text-lg-subtitle-1 text-xl-h6 " v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn

                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list >
              <v-list-item @click="type = 'day'">
                <v-list-item-title  >Dia</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mês</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 dias</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div v-if="!$vuetify.breakpoint.smOnly && !$vuetify.breakpoint.xsOnly"  class="mr-0 mr-lg-3 mr-xl-3">
          <v-btn class="ml-6" icon to="documents">
            <v-icon  class="d-inline">
              mdi-format-list-bulleted
            </v-icon>
          </v-btn>
          </div>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          locale="br"
          v-model="focus"
          :events="events"
          color="primary"
          :type="type"
          :event-color="getEventColor"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="getEvents  "
        ></v-calendar>
      </v-sheet>
      <div  v-if="$vuetify.breakpoint.smOnly || $vuetify.breakpoint.xsOnly" >
        <v-speed-dial
          color="pink"
          fixed
          right
          bottom
          v-model="fab"
        >
          <template v-slot:activator>
            <v-btn
              color="blue darken-2"
              dark
              fab

            >
              <v-icon v-if="fab">
                mdi-plus
              </v-icon>
              <v-icon v-else>
                mdi-filter-variant
              </v-icon>
            </v-btn>
          </template>
          <v-btn
            fab
            dark
            small
            color="green"
            to="documents"
          >
            <v-icon> mdi-format-list-bulleted</v-icon>
          </v-btn>
        </v-speed-dial>
      </div>
    </v-col>
  </v-row>
</template>

<script>
 // import {apolloClient} from '@/vue-apollo'
  export default {

   data:()=>({
    focus: '',
    today: null,
    type: 'month',
    typeToLabel: {
     month: 'Mês',
     week: 'Semana',
     day: 'Dias',
     '4day': '4 Dias',
    },
    fab: false,
    start: null,
    end: null,
    events: [],
    colors:'red',
    names:[]
   }),
   watch:{
    rows(val){
     if(val){
      this.$refs.calendar.checkChange()
     }
    //  else{
    //   console.log('sem dados')
    //  }
    }
   },
   mounted() {
    this.$refs.calendar.checkChange()
   },
   methods:{
    getEventColor (event) {
     let today = new Date().toISOString().slice(0, 10)
     if(today < event.end){
      return 'green'
     }else{
      return event.color
     }

    },
    viewDay ({ date }) {
     this.focus = date
     this.type = 'day'
    },
    setToday () {
     this.focus = ''
    },
    prev () {
     this.$refs.calendar.prev()
    },
    next () {
     this.$refs.calendar.next()
    },
    // eslint-disable-next-line no-unused-vars
   async getEvents () {
     if( this.names.length <= 0){
     await this.$apollo.query({
       query:require("@/graphql/queries/Documents.gql").CustomDocumentBox,
       fetchPolicy: 'no-cache',
      }).then((data)=>{
       this.names = data.data.customDocumentBoxQuery.map((e)=>{

        return  e.document.subject
       })
      this.start = data.data.customDocumentBoxQuery.map((e)=>{
       return  e.document.delivery_time
      })
      this.events = data.data.customDocumentBoxQuery.map((e) =>({
       name:e.document.subject,
       start: e.document.delivery_time,
       end:e.document.delivery_time,
       color: this.colors,
      }))

      }).catch((erro)=>{
        console.log(erro)
     })
     }

    },
   },
  }

</script>

<style scoped>

</style>